module.exports = "<header class=\"wrapper wrapper--header logo-header\">\r\n    <a href=\"#\">\r\n        <img src=\"/Content/Images/creditinfo_master_logo.png\" alt=\"CreditInfo IdentityService\" class=\"logo-image\">\r\n    </a>\r\n    <span class=\"logo-text-container\">\r\n        <span>{{logoText}}</span>\r\n    </span>\r\n</header>";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/templates/common/logoHeader.component.html
// module id = 461
// module chunks = 0